import { useQuery } from '@tanstack/react-query'
import { healthCheck } from '../../../../apis/healthcheck'
import { queryKeys } from '../../../../shared'

type UseHealthCheckQueryOptions = {
  enabled?: boolean
}

/**
 * ヘルスチェック Query hook
 *
 * 10秒間隔でサーバーの死活監視を行う。
 * エラー時はメンテナンスモーダル表示のトリガーとなる。
 *
 * @note retry: false でエラー時即座に状態を反映
 */
export const useHealthCheckQuery = (options?: UseHealthCheckQueryOptions) => {
  return useQuery({
    queryKey: queryKeys.health.check(),
    queryFn: healthCheck,
    refetchInterval: 10000, // 10秒
    retry: false,
    refetchOnWindowFocus: false,
    ...options,
  })
}
